module.exports = __webpack_public_path__ + "static/media/2.870010ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/mobile/2.png
// module id = 2502
// module chunks = 0